import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from '../../../../../app.config';
import { HelpersService } from '../../../../../services';
import { BikeService } from '../../../../../services/bike.service';
import { ChecklistService } from '../../../../../services/checklist.service';
import { CyclistService } from '../../../../../services/cyclist.service';
import { InvoiceService } from '../../../../../services/invoice.service';
import { JobcardService } from '../../../../../services/jobcard.service';
import { PartnerService } from '../../../../../services/partner.service';

@Component({
  selector: 'app-jobcard-checklists',
  templateUrl: './jobcard-checklists.component.html',
  styleUrls: ['./jobcard-checklists.component.scss']
})
export class JobcardChecklistsComponent implements OnInit {

  @Input() jobCardID;

  public partnerID: any;
  public partnerData: any;
  public jobcard: any;
  public serviceTypes: any = [];
  public checklists: any = [];

  constructor(
    public appConfig: AppConfig,
    public helpersService: HelpersService,
    public jobcardService: JobcardService,
    public partnerService: PartnerService,
    public cyclistService: CyclistService,
    public bikeService: BikeService,
    public checklistService: ChecklistService,
    private translate: TranslateService,
    private invoiceService: InvoiceService
  ) { }

  ngOnInit() {
    this.getPatnerDataForCyclistPlatform();
  }

  getPatnerDataForCyclistPlatform() {
    this.partnerService.getPartnerDataCyclistPlatform(this.jobCardID).subscribe(data => {
      this.appConfig.populateDataCyclistPlatform(data);
      this.partnerID = data.partnerID;
      this.getJobCard();
    })
  }

  getJobCard() {
    this.checklistService.getServiceChecklist(this.partnerID, this.jobCardID).subscribe(checklist => {
      this.checklists = checklist;
      this.checklists.forEach(x => x.defaultValue == null ? x.defaultValue = "" : x.defaultValue);
      this.checklists.forEach(x => x.frontValue == null ? x.frontValue = "" : x.frontValue);
      this.checklists.forEach(x => x.rearValue == null ? x.rearValue = "" : x.rearValue);
    }, err => {

    });
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

}
